module.exports = new __parcel__URL__("pr-details-popup.tpl.2fd71422.svg").toString();